export default __webpack_public_path__ + "static/media/ProfileIcon.66ee3b9f.svg";